import { call, put, select } from 'redux-saga/effects';
import { apiRequest } from '../../api/api.saga-services';
import { ICreateTenantFromUserData, IAddUserToTenantData, ISwitchTenantData, ITenant } from './user-tenants.types';
import * as userTenantsApi from '../../api/request-config/user-tenant.api';
import * as userTenantActions from './user-tenants.actions';
import { push } from 'connected-react-router';
import * as pageService from '../../page/page.initializer.saga-service';
import * as resourceService from '../../resource/resource.destructor.saga-service';
import { updateLoggedUserdata } from '../../auth/auth.saga-services';
import { addFlashMessage } from '../../../utils/flashMessages.utils';
import { IUser } from '../user/user.types';
import * as dialogService from '../../dialog/dialog.saga-services';
import { storeUser } from '../user/user.saga-service';
import { usersPageSelectors } from '../../page/page-storage/users/users.selectors';
import * as userPageActions from '../../page/page-storage/users/users.actions';
import { userTenantsSelectors } from './user-tenants.selectors';
import { searchSettings } from '../settings/settings.saga-service';

export function* storeUserTenants(userTenants: ITenant[]) {
  yield put(userTenantActions.storeUserTenants(userTenants));
  return userTenants;
}

export function* switchTenant(data: ISwitchTenantData) {
  const response = yield call(apiRequest, userTenantsApi.switchTenantApi(data.tenantId));
  if (!response) {
    return;
  }
  yield call(pageService.uninitPage);
  yield call(resourceService.uninitResources);
  yield call(updateLoggedUserdata, response);
  yield call(searchUserTenants);
  yield call(searchSettings);
  // Used on the next login (API last_tenant_selected) and on reload (loadCachedUser /
  // X-Tenant-Id fallback). The JWT no longer encodes the current workspace.
  localStorage.setItem('last_tenant_selected', response.tenantId);
  yield put(push(`/`));
}

export function* addUserToTenant(data: IAddUserToTenantData) {
  const response = yield call(apiRequest, userTenantsApi.addUserToTenantApi(data.id));
  if (!response) {
    return;
  }

  yield call(storeUser, response);
  const activeUserIds = (yield select(usersPageSelectors.selectActiveUserIds)) as IUser['id'][];
  yield put(userPageActions.storeFetchedActiveUsers([...activeUserIds, response.id]));

  yield call(addFlashMessage, { type: 'success', message: 'User has been added to this workspace' });
  yield call(dialogService.closeDialog, 'newUserFormDialog');
}
export function* createUserTenant(data: ICreateTenantFromUserData) {
  const payload = {
    tenant: {
      name: data.tenantName,
    },
  };
  const response: {
    user: IUser;
    tenant: ITenant;
  } = yield call(apiRequest, userTenantsApi.createTenantApi(payload));
  if (!response) {
    return;
  }
  yield call(dialogService.closeDialog, 'workspaceCreationDialog');
  yield call(switchTenant, { tenantId: response.tenant.id });
}
export function* searchUserTenants() {
  const tenants = (yield call(apiRequest, userTenantsApi.searchUserTenantsApi()) as unknown) as ITenant[];
  if (!tenants) {
    return;
  }
  yield call(storeUserTenants, tenants);
  return tenants;
}

export function* clearAllUserTenants() {
  const userTenantIds: ITenant['id'][] = yield select(userTenantsSelectors.selectResourceIds);
  yield put(userTenantActions.clearUserTenants(userTenantIds));
}
